function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import DownloadBlockedAttachment from "./DownloadBlockedAttachment";
import { CrossIcon, MaliciousFileIcon } from "../../../../../../assets/Icons";
const MaliciousAttachment = props => {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  const extraContent = /*#__PURE__*/React.createElement("img", {
    src: CrossIcon,
    alt: "download blocked icon"
  });
  return /*#__PURE__*/React.createElement(DownloadBlockedAttachment, _extends({}, props, {
    iconData: MaliciousFileIcon,
    extraContent: extraContent
  }));
};
export default MaliciousAttachment;